const settings = {
  title: 'Postavke',
  profile: 'Profil',
  signOut: 'Odjava',
  saved: 'Postavke spremljene',
  errorSaving: 'Greška pri spremanju postavki',

  versionInfo: 'Informacije o verziji',
  versionInfoDescription:
    'Podrška može zatražiti ove brojeve prilikom rješavanja problema.',
  nativeVersion: 'Native verzija',
  bundleVersion: 'Verzija paketa',
  buildNumber: 'Broj međuverzije (Build)',
  unknown: 'Nepoznato',

  appSettings: 'Postavke aplikacije',
  transcriptionSettings: 'Postavke transkripcije',

  changeLanguage: 'Promijeni jezik',
  context: 'Pojmovi koje AI teže prepoznaje',
  contextPlaceholder: 'Xanax, Controloc, Klavocin, ...',
  specialization: 'Specijalizacija',
  specializationPlaceholder: 'kardiologija, endokrinologija, ...',
  clinic: 'Ordinacija',
  clinicPlaceholder: 'obiteljska medicina, kardiologija, ...',
  customTemplates: 'Prilagođeni predlošci',
  contactUsDescription:
    'Za prilagođene predloške dokumenata i softverske integracije, kontaktirajte nas na ',
  contactUsButton: 'Kontaktirajte nas',

  subscription: {
    title: 'Pretplata',
    used: 'Iskorišteno {{count}} od {{max}} besplatnih izvještaja ovaj mjesec.',
    subscribedPrefix: 'Pretplaćeni ste na ',
    subscribedSuffix: ' paket.',
    manage: 'Upravljanje pretplatom',
    manageSubscriptionError: 'Nije moguće otvoriti upravljanje pretplatom.',
    subscribe: 'Pretplati se',
    restorePurchase: 'Obnovi kupnju',
    restoringPurchases: 'Obnavljanje kupnje...',
    purchasesRestoredSuccessfully: 'Kupnja uspješno obnovljena',
    noPurchasesFound: 'Kupnja nije pronađena',
    privacyPolicy: 'Politika privatnosti',
    termsOfService: 'Uvjeti korištenja',
    packages: {
      $rc_monthly: 'Mjesečni Pro ({{price}})',
      $rc_annual: 'Godišnji Pro ({{price}})',
    },
  },
};

export default settings;
